import { render, staticRenderFns } from "./conference.vue?vue&type=template&id=f04f05de&scoped=true&"
import script from "./conference.vue?vue&type=script&lang=js&"
export * from "./conference.vue?vue&type=script&lang=js&"
import style0 from "./conference.vue?vue&type=style&index=0&id=f04f05de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04f05de",
  null
  
)

export default component.exports